module.exports = __webpack_public_path__ + "media/chess_piece.b0bdb252.mp3";